module.exports = __webpack_public_path__ + "static/img/XSPA.560655e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/XSPA.png
// module id = FexX
// module chunks = 1